import { useFormContext } from "react-hook-form";

import { Input } from "src/base-components/Input";
import { ErrorHint } from "src/design-system/ErrorHint";
import { Icon } from "src/design-system/Icon";
import { Skeleton } from "src/design-system/Skeleton";
import { getSchemaIcon } from "src/entities/entityView/utils";
import { EntitySchemaResource } from "src/entities/queries";

export const SchemaBaseEditor: React.FC<{
  isLoading: boolean;
}> = ({ isLoading }) => {
  const form = useFormContext<EntitySchemaResource>();
  const schemaIcon = getSchemaIcon(form.getValues());

  return (
    <div className="flex gap-x-2">
      <div className="flex h-15 w-15 shrink-0 items-center justify-center rounded-xl border border-gray-200">
        {isLoading ? (
          <Skeleton height="h-6" width="w-6" />
        ) : (
          <Icon icon={schemaIcon} size="md" />
        )}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-y-2">
        <div className="font-inter-normal-12px text-gray-500">Name</div>
        {isLoading ? (
          <Skeleton height="h-8" rounded="rounded-lg" width="w-full" />
        ) : (
          <Input
            disabled
            fullWidth
            monospaced
            {...form.register("_id", { required: true })}
          />
        )}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-y-2">
        <div className="font-inter-normal-12px text-gray-500">
          Display Name Singular
        </div>
        {isLoading ? (
          <Skeleton height="h-8" rounded="rounded-lg" width="w-full" />
        ) : (
          <Input
            errored={!!form.formState.errors._display_name_singular}
            fullWidth
            {...form.register("_display_name_singular", {
              required: "This field is required",
            })}
          />
        )}
        {form.formState.errors._display_name_singular && (
          <ErrorHint>
            {form.formState.errors._display_name_singular?.message}
          </ErrorHint>
        )}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-y-2">
        <div className="font-inter-normal-12px text-gray-500">
          Display Name Plural
        </div>
        {isLoading ? (
          <Skeleton height="h-8" rounded="rounded-lg" width="w-full" />
        ) : (
          <Input
            errored={!!form.formState.errors._display_name_plural}
            fullWidth
            {...form.register("_display_name_plural", {
              required: "This field is required",
            })}
          />
        )}
        {form.formState.errors._display_name_plural && (
          <ErrorHint>
            {form.formState.errors._display_name_plural?.message}
          </ErrorHint>
        )}
      </div>
    </div>
  );
};
